import React, { useState } from 'react'

import { useParams } from 'react-router-dom'

import ErrorState from 'components/ErrorState'
import ExternalNavLink from 'components/lib/ExternalNavLink'
import Loader from 'components/lib/Loader'
import { PublicQuestions } from 'components/Survey/Survey'
import SurveyRouter from 'components/SurveyRouter'
import { ParticipantSourceTypeInput, useSurveyByIdQuery } from 'generated/graphql'
import { useTranslations, TranslationKey } from 'locales'
import { WALLE_URLS } from 'utils/constants'
import { LOCTypeEnum } from 'utils/generatedFrontendConstants'

const PreviewContainer: React.FC = () => {
  const { t } = useTranslations()
  const { surveyId, source } = useParams<{
    surveyId: string
    source: ParticipantSourceTypeInput
  }>()
  const [responses, setResponses] = useState<{ [key: string]: string }>({})

  const result = useSurveyByIdQuery({
    variables: { surveyId: surveyId || '' },
    skip: !surveyId,
  })
  if (result.loading) {
    return <Loader />
  }
  if (!surveyId || !result?.data?.surveyById) {
    return <ErrorState message={t('Error: URL missing a survey ID.')} />
  }
  const participant = result?.data?.surveyById?.participant

  // Check if the survey has a location
  if (!participant.locationExists) {
    return (
      <ErrorState
        message={
          <>
            {t('You need a location to preview the survey. Add locations')}{' '}
            <ExternalNavLink
              to={`${WALLE_URLS.SETTINGS.LOCATIONS}/${result?.data?.surveyById?.organization.locationFilterTypeUuid}`}
              label={t('here')}
            />
            .
          </>
        }
      />
    )
  }
  const {
    type,
    productType,
    welcomeMessage,
    hasConfidentialResults,
    isOpenLinkSurvey,
    languages,
    translations,
    transitionTexts,
  } = result.data.surveyById

  let templates: { [key: string]: string } = {}
  if (participant.templates) {
    templates = JSON.parse(participant.templates)
    templates = Object.keys(templates).reduce(
      (acc, key) => ({ ...acc, [key]: t(templates[key] as TranslationKey) }),
      {},
    )
  }

  return (
    <SurveyRouter
      participantIsExpired={false}
      surveyType={type}
      surveyProductType={productType}
      isOpenLinkSurvey={isOpenLinkSurvey}
      hasConfidentialResults={hasConfidentialResults}
      questions={participant.questions as PublicQuestions}
      levelOfCare={participant.levelOfCare as LOCTypeEnum}
      templates={templates}
      responses={responses}
      welcomeMessage={welcomeMessage}
      updateResponses={(response: string, code: string) =>
        setResponses({ ...responses, [code]: response })
      }
      onlineReviewSites={participant.location?.onlineReviewSites}
      languages={languages}
      translations={translations}
      transitionTexts={transitionTexts}
      source={source as ParticipantSourceTypeInput}
      isPreview
    />
  )
}

export default PreviewContainer
